const attackModifierData = {
  1: {
    attackMultiplier: 0.8,
  },
  2: {
    attackMultiplier: 1,
  },
  3: {
    attackMultiplier: 1.2,
  },
  4: {
    attackMultiplier: 1,
  },
};

export default attackModifierData;
